import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { PainPoints } from "./components/sections/PainPoints";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { FAQ } from "./components/sections/FAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";
const FIRST_CTA_ID = "first-cta";
export function App() {
  return <div className="w-full overflow-x-hidden bg-canvas font-sans text-ink" data-id="element-0" data-mp="3ik7eyd5x05p2">
      <MetaPixel data-id="element-1" data-mp="3ii4s22026sok" />
      <Hero firstCtaId={FIRST_CTA_ID} data-id="element-2" data-mp="3mlavz2zp87rv" />
      <main data-id="element-3" data-mp="3mk852v2dm5by">
        <BeforeAfter data-id="element-4" data-mp="3mjzpgvevclx2" />
        <PainPoints data-id="element-5" data-mp="3mj6hxs835sdv" />
        <Volumes data-id="element-6" data-mp="3rcj8i7wbs999" />
        <Tools data-id="element-7" data-mp="3rbznujfaj6rj" />
        <Bonuses data-id="element-8" data-mp="3rdkgg3i1ofmr" />
        <Offer data-id="element-9" data-mp="3rd19tixuhdo1" />
        <Guarantee data-id="element-10" data-mp="3relumgucxi8p" />
        <Testimonials data-id="element-11" data-mp="5or2zhbcs60" />
        <Author data-id="element-12" data-mp="682rygdekbl" />
        <FAQ data-id="element-13" data-mp="4n7g6m8exco" />
        <FinalCTA data-id="element-14" data-mp="56lvdcob3ly" />
      </main>
      <Footer data-id="element-15" data-mp="2zl3cjn8vpa6d" />
      <FloatingCTA anchorId={FIRST_CTA_ID} data-id="element-16" data-mp="2zlldgx6hkckm" />
      <PurchasePopup data-id="element-17" data-mp="2zmwif0bo3qdb" />
    </div>;
}